/**
 * 国家电话代码
 * @Author: fjj
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2022.04.21      1.0     First version
 *
 * @param onItemClicked  当点击后回调(telCode)
 * @param isDisabled  是否不可编辑，默认false，可编辑
 *  //todo 优化右模糊
 *
 * Copyright 2017-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Select } from 'antd';
import Locale from "@utils/locale";

const { Option } = Select;
class TelephoneCode extends React.Component {
    static propTypes = {
        // onItemClicked: React.PropTypes.func.isRequired,  //当点击后回调
        // isDisabled: React.PropTypes.bool,  //是否不能修改
        // defaultItemId: React.PropTypes.string, //这个是号码前缀。
        // defaultItemCode: React.PropTypes.string, //这个是号码前端Code
    }
    static defaultProps = {
        //是否不能修改
        isDisabled: false,
        // defaultItemId: '',      //这个是号码前缀。如：中国 +86，美国 +1
        // defaultItemCode: '',    //这个是号码前端Code。如：中国 142，美国 502
        width:100
    };
    constructor(props) {
        super(props);
        this.state={
            list :[],
            loading:false,
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求电话列表
     * */
    getList(){
        const { defaultItemCode,onItemClicked } = this.props;
        // const sUrl = "/data/pub/r/region/country-telcode";
        const sUrl = "/service/fenxiao/query/region/"+Locale.current();
        this.loading(true)
        this.postHttpAction(sUrl,resData=>{
            // 响应结果
            let { success, valid, models, model } = resData;
            if (success && valid) {
                this.loading(false)
                // 返回状态
                if(models&&models.length>0){
                    const objDefault = defaultItemCode?models.find(item=>item.telCode==defaultItemCode):models.find(item=>item.abbreviate=='RU')// 默认俄罗斯联邦
                    const sDefuatCode = objDefault&&objDefault.code?objDefault.code:'';
                    const sDefuatTelCode = objDefault&&objDefault.telCode?objDefault.telCode:'';
                    this.props.onItemClicked(sDefuatTelCode);
                    this.setState({
                        list : models||[],
                        defaultItem: sDefuatCode,
                    })
                }
            }
        })
    }
    /**
     * 请求
     * */
    postHttpAction(sUrl,callback){
        return $.ajax({
            url: sUrl,
            type:'get',
            // dataType: "json",
            // contentType: 'application/json',
            success:(res)=>{
                callback(res)
            }
        });
    }
    // 输出
    renderOptions(list=[]){
        const enumChildren = [];
        list.forEach((area,inx)=>{
            enumChildren.push(<Option key={area.code+'_'+inx} value={area.code} label={'+ '+area.telCode}>+{area.telCode}<span className={'margin-left-5'}>{area.name}</span></Option>);
        })
        return enumChildren;
    }
    /**
     * 修改值
     * */
    onChange = (value,option) => {
        const { list } =this.state;
        const current = list.find(item=>item.code==value)||{};
        const telCode = current.telCode||'';
        this.props.onItemClicked(telCode);
        this.setState({
            defaultItem: value
        })

    };
    componentWillMount() {
        this.getList()
    }
    componentDidMount() {
        if(this.props.onRef)  this.props.onRef(this);
    }

    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { defaultItem, list, loading } = this.state;
        const { isDisabled,width } = this.props;
        return (<Select popupMatchSelectWidth={false}
                        disabled={isDisabled}
                        showSearch
                        filterOption={(input, option) =>option.label.indexOf(input) >= 0}
                        loading={loading}
                        optionLabelProp={'label'}
                        value={defaultItem}
                        onChange={this.onChange}
                        style={{ width: width  }}>
            {this.renderOptions(list)}
        </Select>)

    }
}

export default TelephoneCode;

